import { Routes, Route } from "react-router-dom";

import AdminCriteriaSection from "./sections/adminCriteriaSections";

function CriteriaApp() {
  return (
    <Routes>
       <Route path="/" element={<AdminCriteriaSection />} />
        {/*  <Route path="*" element={<Navigate to="/page404" replace />} /> */}
    </Routes>
  );
}

export default CriteriaApp;